import { fileService } from "@/services/ServiceRegistry";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { useCreateRoomCategory } from "@/hooks/useRoomCategories";
import { CreateRoomCategoryFormData } from "../../utils/categorySchema";
import { CreateRoomCategoryRequest } from "@/types/roomCategory";

export const useCategoryCreate = () => {
  const navigate = useNavigate();
  const createRoomCategoryMutation = useCreateRoomCategory();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRoomCategoryCreate = async (
    data: Omit<CreateRoomCategoryFormData, "customFeatures">,
    hotelId: string,
    selectedPhotoFile: File | null,
  ) => {
    try {
      setIsLoading(true);
      const { price, ...roomData } = data;

      let photoFileId = null;

      if (selectedPhotoFile) {
        try {
          photoFileId =
            await fileService.uploadFileWithPresignedUrl(selectedPhotoFile);
        } catch (photoError) {
          console.error("Failed to upload photo:", photoError);
        }
      }

      const roomRequest: CreateRoomCategoryRequest = {
        ...roomData,
        ...(photoFileId && { photoId: photoFileId }),
        price: parseFloat(price),
        hotelId: hotelId!,
      };

      // Create the room using the service
      await createRoomCategoryMutation.mutateAsync(roomRequest);

      // Navigate back to reservations list
      navigate("/reservations/rooms/categories");
    } catch (error) {
      toast.error((error as Error).message);
      setError((error as Error).message);
      console.error("Error creating room:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleRoomCategorySubmit: handleRoomCategoryCreate,
    isLoading: isLoading,
    error: error,
  };
};
